import { useEffect, useRef, useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

const WS_BASE = process.env.REACT_APP_WS_URL || `wss://${window.location.host}`;

export function useWebSocket(onMessage) {
  const { getToken } = useAuth();
  const wsRef = useRef(null);
  const [status, setStatus] = useState('connecting');
  const reconnectRef = useRef(null);
  const onMessageRef = useRef(onMessage);
  onMessageRef.current = onMessage;

  const connect = useCallback(() => {
    const token = getToken();
    if (!token) return;

    const url = `${WS_BASE}/ws?token=${encodeURIComponent(token)}`;
    const ws = new WebSocket(url);
    wsRef.current = ws;

    ws.onopen = () => {
      setStatus('connected');
      if (reconnectRef.current) {
        clearTimeout(reconnectRef.current);
        reconnectRef.current = null;
      }
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        onMessageRef.current?.(data);
      } catch {}
    };

    ws.onclose = () => {
      setStatus('disconnected');
      reconnectRef.current = setTimeout(connect, 4000);
    };

    ws.onerror = () => {
      setStatus('error');
      ws.close();
    };
  }, [getToken]);

  useEffect(() => {
    connect();
    return () => {
      if (reconnectRef.current) clearTimeout(reconnectRef.current);
      wsRef.current?.close();
    };
  }, [connect]);

  return status;
}
